<template>
	<form-table v-bind="$attrs">
		<slot></slot>
		<sc-table-column
			v-bind="item"
			v-for="(item, index) in columns"
			:key="index"
		></sc-table-column>
		<slot name="append"></slot>
		<el-table-column min-width="1"></el-table-column>
	</form-table>
</template>

<script>
import FormTable from "@/components/form-table/index.vue";
import ScTableColumn from "@/components/pro-table/columns/tableColumn.vue";

export default {
	name: 'ProFormTable',
	components: {ScTableColumn, FormTable},
	props: {
		columns: {
			type: Array,
			default: () => ([])
		},
	},
	setup() {


		return {}
	}
}
</script>

<style lang="scss" scoped>

</style>
